import styled from 'styled-components';

export const TitleFilter = styled.div`
    width: 100%;
    display: inline-flex;
    align-items: baseline;
`;
